var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0697F5DF-232C-43DC-AEAD-D2D27E4F14DE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CoreFit-Landing-Page-Option3",
    transform: "translate(-668.000000, -4965.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 4836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-us-grp",
    transform: "translate(665.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_phone",
    transform: "translate(4.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.27378,11.98568 C10.27378,11.98568 11.65044,11.19756 12.01084,11.00818 C12.37022,10.81812 12.74252,10.77018 12.96862,10.90822 C13.311,11.11766 16.18604,13.03016 16.42812,13.19948 C16.6702,13.36914 16.78682,13.85364 16.45396,14.32828 C16.12246,14.80292 14.59314,16.67972 13.9451,16.6598196 C13.29604,16.63858 10.59746,16.57942 5.50868,11.48928 C0.42092,6.40084 0.36074,3.70158 0.34,3.05252 C0.31926,2.4038 2.19606,0.87414 2.6707,0.5423 C3.14602,0.2108 3.6312,0.33558 3.79984,0.56882 C3.9916,0.83436 5.882,3.70022 6.09008,4.02866 C6.23254,4.25306 6.18018,4.6274 5.99012,4.98712 C5.80108,5.34752 5.01296,6.72418 5.01296,6.72418 C5.01296,6.72418 5.56852,7.67176 7.44736,9.55026 C9.32654,11.4291 10.27378,11.98568 10.27378,11.98568 Z",
    id: "Path",
    stroke: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.b63ec606af8eeee346b4e403b5799566.svg";
export { ForwardRef as ReactComponent };